var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgressReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.94414 14.8164H13.4002C13.6005 14.8164 13.7627 14.6541 13.7627 14.4539C13.7627 14.2537 13.6005 14.0914 13.4002 14.0914H3.94414C3.7439 14.0914 3.58164 14.2537 3.58164 14.4539C3.58164 14.6542 3.74401 14.8164 3.94414 14.8164Z",
    fill: "#DBDFF5",
    stroke: "#DBDFF5",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7627 17.0923C13.7627 16.8921 13.6005 16.7298 13.4002 16.7298H3.94414C3.7439 16.7298 3.58164 16.8921 3.58164 17.0923C3.58164 17.2926 3.7439 17.4548 3.94414 17.4548H13.4002C13.6005 17.4548 13.7627 17.2926 13.7627 17.0923Z",
    fill: "#DBDFF5",
    stroke: "#DBDFF5",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.247 8.90313H6.28851V11.6773C6.28851 11.8775 6.45078 12.0398 6.65101 12.0398H10.6775C10.8778 12.0398 11.04 11.8775 11.04 11.6773V8.90313H13.0984C13.2415 8.90313 13.3713 8.81891 13.4295 8.68821L13.4295 8.68818C13.4877 8.55744 13.4635 8.40469 13.3679 8.2983L13.3679 8.29825L8.94217 3.37727L8.94212 3.37722C8.80268 3.22237 8.54253 3.22237 8.40308 3.37722L8.40304 3.37727L3.9773 8.29825L3.97729 8.29826C3.88168 8.40462 3.85754 8.55738 3.91567 8.68815L3.91573 8.68828C3.97401 8.81887 4.10367 8.90313 4.24682 8.90313H4.247ZM5.06067 8.17813L8.67274 4.16163L12.2849 8.17813H10.6777C10.4775 8.17813 10.3152 8.34039 10.3152 8.54063V11.3148H7.01368V8.54063C7.01368 8.34039 6.85142 8.17813 6.65119 8.17813H5.06067Z",
    fill: "#DBDFF5",
    stroke: "#DBDFF5",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7374 2.57899H16.4448V1.2625C16.4448 1.06226 16.2825 0.9 16.0823 0.9H1.2625C1.06226 0.9 0.9 1.06226 0.9 1.2625V20.0585C0.9 20.2587 1.06226 20.421 1.2625 20.421H6.5551V21.7375C6.5551 21.9377 6.71737 22.1 6.9176 22.1H21.7374C21.9377 22.1 22.0999 21.9377 22.0999 21.7375V2.94149C22.0999 2.74125 21.9377 2.57899 21.7374 2.57899ZM1.625 1.625H15.7198V19.696H1.625V1.625ZM21.3749 21.3749H7.2801V20.4209H16.0825C16.2828 20.4209 16.445 20.2587 16.445 20.0584V3.30403H21.3751L21.3749 21.3749Z",
    fill: "#DBDFF5",
    stroke: "#DBDFF5",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressReport);
export default __webpack_public_path__ + "static/media/progressReport.92cd5b8af093fcabdd923dcbc3c3fa50.svg";
export { ForwardRef as ReactComponent };